import { DropdownItem } from "@mcleod/components";
import { AutogenLayoutFmProfileDataOutputTable } from "./autogen/AutogenLayoutFmProfileDataOutputTable";
import { FmDataOutputType } from "./FreightMatchingUtil";

export class FmProfileDataOutputTable extends AutogenLayoutFmProfileDataOutputTable {
    private tableItems: DropdownItem[];
    private type: FmDataOutputType;

    initialize(type: FmDataOutputType): void {
        this.type = type;
    }

    public getTableItems(): DropdownItem[] {
        return this.tableItems;
    }

    public setTableItems(items: DropdownItem[]): void {
        this.tableItems = items;
    }

    public getType(): FmDataOutputType {
        return this.type;
    }
}